import { useEffect } from 'react';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { ensureMap } from '../../hocs/ensureMap';
var XYZLayer = ensureMap(function (_ref) {
  var id = _ref.id,
    name = _ref.name,
    map = _ref.map,
    url = _ref.url,
    urls = _ref.urls,
    zIndex = _ref.zIndex,
    minZoom = _ref.minZoom,
    maxZoom = _ref.maxZoom,
    crossOrigin = _ref.crossOrigin,
    opacity = _ref.opacity;
  useEffect(function () {
    var layer = new TileLayer({
      source: new XYZ({
        url: url,
        urls: urls,
        crossOrigin: crossOrigin || 'Anonymous'
      }),
      zIndex: zIndex,
      minZoom: minZoom,
      maxZoom: maxZoom,
      opacity: opacity
    });
    map.addLayer(layer);
    return function () {
      map.removeLayer(layer);
    };
  }, [id, name, map, url, urls, crossOrigin, zIndex, minZoom, maxZoom, opacity]);
  return null;
});
export default XYZLayer;